/*undefined*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.BankUndepositedFundFilter = (function() {

    /**
     * Namespace BankUndepositedFundFilter.
     * @exports BankUndepositedFundFilter
     * @namespace
     */
    var BankUndepositedFundFilter = {};

    BankUndepositedFundFilter.BankUndepositedFundFilterModel = (function() {

        /**
         * Properties of a BankUndepositedFundFilterModel.
         * @memberof BankUndepositedFundFilter
         * @interface IBankUndepositedFundFilterModel
         * @property {string|null} [query] BankUndepositedFundFilterModel query
         * @property {string|null} [sortColumn] BankUndepositedFundFilterModel sortColumn
         * @property {string|null} [sortOrder] BankUndepositedFundFilterModel sortOrder
         * @property {number|null} [pageIndex] BankUndepositedFundFilterModel pageIndex
         * @property {number|null} [pageSize] BankUndepositedFundFilterModel pageSize
         */

        /**
         * Constructs a new BankUndepositedFundFilterModel.
         * @memberof BankUndepositedFundFilter
         * @classdesc Represents a BankUndepositedFundFilterModel.
         * @implements IBankUndepositedFundFilterModel
         * @constructor
         * @param {BankUndepositedFundFilter.IBankUndepositedFundFilterModel=} [p] Properties to set
         */
        function BankUndepositedFundFilterModel(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * BankUndepositedFundFilterModel query.
         * @member {string|null|undefined} query
         * @memberof BankUndepositedFundFilter.BankUndepositedFundFilterModel
         * @instance
         */
        BankUndepositedFundFilterModel.prototype.query = null;

        /**
         * BankUndepositedFundFilterModel sortColumn.
         * @member {string|null|undefined} sortColumn
         * @memberof BankUndepositedFundFilter.BankUndepositedFundFilterModel
         * @instance
         */
        BankUndepositedFundFilterModel.prototype.sortColumn = null;

        /**
         * BankUndepositedFundFilterModel sortOrder.
         * @member {string|null|undefined} sortOrder
         * @memberof BankUndepositedFundFilter.BankUndepositedFundFilterModel
         * @instance
         */
        BankUndepositedFundFilterModel.prototype.sortOrder = null;

        /**
         * BankUndepositedFundFilterModel pageIndex.
         * @member {number|null|undefined} pageIndex
         * @memberof BankUndepositedFundFilter.BankUndepositedFundFilterModel
         * @instance
         */
        BankUndepositedFundFilterModel.prototype.pageIndex = null;

        /**
         * BankUndepositedFundFilterModel pageSize.
         * @member {number|null|undefined} pageSize
         * @memberof BankUndepositedFundFilter.BankUndepositedFundFilterModel
         * @instance
         */
        BankUndepositedFundFilterModel.prototype.pageSize = null;

        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;

        /**
         * BankUndepositedFundFilterModel _query.
         * @member {"query"|undefined} _query
         * @memberof BankUndepositedFundFilter.BankUndepositedFundFilterModel
         * @instance
         */
        Object.defineProperty(BankUndepositedFundFilterModel.prototype, "_query", {
            get: $util.oneOfGetter($oneOfFields = ["query"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * BankUndepositedFundFilterModel _sortColumn.
         * @member {"sortColumn"|undefined} _sortColumn
         * @memberof BankUndepositedFundFilter.BankUndepositedFundFilterModel
         * @instance
         */
        Object.defineProperty(BankUndepositedFundFilterModel.prototype, "_sortColumn", {
            get: $util.oneOfGetter($oneOfFields = ["sortColumn"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * BankUndepositedFundFilterModel _sortOrder.
         * @member {"sortOrder"|undefined} _sortOrder
         * @memberof BankUndepositedFundFilter.BankUndepositedFundFilterModel
         * @instance
         */
        Object.defineProperty(BankUndepositedFundFilterModel.prototype, "_sortOrder", {
            get: $util.oneOfGetter($oneOfFields = ["sortOrder"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * BankUndepositedFundFilterModel _pageIndex.
         * @member {"pageIndex"|undefined} _pageIndex
         * @memberof BankUndepositedFundFilter.BankUndepositedFundFilterModel
         * @instance
         */
        Object.defineProperty(BankUndepositedFundFilterModel.prototype, "_pageIndex", {
            get: $util.oneOfGetter($oneOfFields = ["pageIndex"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * BankUndepositedFundFilterModel _pageSize.
         * @member {"pageSize"|undefined} _pageSize
         * @memberof BankUndepositedFundFilter.BankUndepositedFundFilterModel
         * @instance
         */
        Object.defineProperty(BankUndepositedFundFilterModel.prototype, "_pageSize", {
            get: $util.oneOfGetter($oneOfFields = ["pageSize"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Encodes the specified BankUndepositedFundFilterModel message. Does not implicitly {@link BankUndepositedFundFilter.BankUndepositedFundFilterModel.verify|verify} messages.
         * @function encode
         * @memberof BankUndepositedFundFilter.BankUndepositedFundFilterModel
         * @static
         * @param {BankUndepositedFundFilter.IBankUndepositedFundFilterModel} m BankUndepositedFundFilterModel message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BankUndepositedFundFilterModel.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.query != null && Object.hasOwnProperty.call(m, "query"))
                w.uint32(10).string(m.query);
            if (m.sortColumn != null && Object.hasOwnProperty.call(m, "sortColumn"))
                w.uint32(18).string(m.sortColumn);
            if (m.sortOrder != null && Object.hasOwnProperty.call(m, "sortOrder"))
                w.uint32(26).string(m.sortOrder);
            if (m.pageIndex != null && Object.hasOwnProperty.call(m, "pageIndex"))
                w.uint32(32).int32(m.pageIndex);
            if (m.pageSize != null && Object.hasOwnProperty.call(m, "pageSize"))
                w.uint32(40).int32(m.pageSize);
            return w;
        };

        /**
         * Encodes the specified BankUndepositedFundFilterModel message, length delimited. Does not implicitly {@link BankUndepositedFundFilter.BankUndepositedFundFilterModel.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BankUndepositedFundFilter.BankUndepositedFundFilterModel
         * @static
         * @param {BankUndepositedFundFilter.IBankUndepositedFundFilterModel} message BankUndepositedFundFilterModel message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BankUndepositedFundFilterModel.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a BankUndepositedFundFilterModel message from the specified reader or buffer.
         * @function decode
         * @memberof BankUndepositedFundFilter.BankUndepositedFundFilterModel
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {BankUndepositedFundFilter.BankUndepositedFundFilterModel} BankUndepositedFundFilterModel
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BankUndepositedFundFilterModel.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.BankUndepositedFundFilter.BankUndepositedFundFilterModel();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.query = r.string();
                    break;
                case 2:
                    m.sortColumn = r.string();
                    break;
                case 3:
                    m.sortOrder = r.string();
                    break;
                case 4:
                    m.pageIndex = r.int32();
                    break;
                case 5:
                    m.pageSize = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        /**
         * Decodes a BankUndepositedFundFilterModel message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BankUndepositedFundFilter.BankUndepositedFundFilterModel
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BankUndepositedFundFilter.BankUndepositedFundFilterModel} BankUndepositedFundFilterModel
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BankUndepositedFundFilterModel.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        return BankUndepositedFundFilterModel;
    })();

    return BankUndepositedFundFilter;
})();

module.exports = $root;
